import _memoize from 'lodash/memoize';
import { getFont, FONT } from '@tornado-rdk/typography';
import { PRIMARY, DARK_MODE, makeThemeColor } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../tornado/utils/style';
import { SCREEN_HEIGHT, SCREEN_WIDTH, getCenter } from '../tornado/utils/sizes';
import { DEFAULT_CONTAINER_SCALE } from './subtitles.constants';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  text: makeThemeColor(PRIMARY),
};

export const getFullContainerWidth = screenSize => SCREEN_WIDTH[screenSize];

export const getFullContainerHeight = screenSize => SCREEN_HEIGHT[screenSize];

export const getInitialStyle = _memoize(() => ({
  Regions: {},
}));

export const INNER_PADDING = {
  [HD]: 6,
  [FULL_HD]: 8,
};

export const getDefaultRegionStyle = _memoize(screenSize => {
  const containerWidth = getFullContainerWidth(screenSize);
  const containerHeight = getFullContainerHeight(screenSize);

  return {
    w: containerWidth * DEFAULT_CONTAINER_SCALE,
    h: containerHeight * DEFAULT_CONTAINER_SCALE,
    x: getCenter(containerWidth, containerWidth * DEFAULT_CONTAINER_SCALE),
    y: getCenter(containerHeight, containerHeight * DEFAULT_CONTAINER_SCALE),
    flex: {
      direction: 'column',
      // alignItems: 'center',
      justifyContent: 'flex-end',
    },
  };
});

export const getItemStyle = _memoize(({ screenSize } = defaultContext) => {
  const font = getFont(FONT.OSLO_2, screenSize);
  const color = colors.text[DARK_MODE];
  const containerWidth = getFullContainerWidth(screenSize);
  const padding = INNER_PADDING[screenSize];

  return {
    text: {
      ...font,
      textColor: color,
      highlightPaddingLeft: padding,
      paddingLeft: padding,
      highlightPaddingRight: padding,
      paddingRight: padding,
      wordWrapWidth: containerWidth,
      textBaseline: 'alphabetic',
      verticalAlign: 'middle',
    },
  };
});
